import { render } from "./ProgramTagListViewEditItemPane.vue?vue&type=template&id=2fb0f11f&scoped=true&ts=true"
import script from "./ProgramTagListViewEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramTagListViewEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramTagListViewEditItemPane.vue?vue&type=style&index=0&id=2fb0f11f&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb0f11f"]])

export default __exports__